import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import toastr from 'toastr';

import { HeaderBar } from '../components/HeaderBar.js';
import { CollapsablePanel } from '../components/CollapsablePanel';
import { TruckSelectionPanel } from '../components/TruckSelectionPanel';
import { RouteListPanel } from '../components/RouteListPanel';
import { MapPanel } from '../components/MapPanel';
import { SummaryPanel } from '../components/SummaryPanel';
import { ChartPanel } from '../components/ChartPanel';
import Modal from '../lib/modal-shim';
import { ModalChatPanel}  from '../components/ModalChatPanel';
import { ModalDriverPanel}  from '../components/ModalDriverPanel';
import { MessagePanelSmall } from '../components/MessagePanelSmall';

import trucksData  from '../data/Trucks.js';
import routesData  from '../data/Routes.js';

export class TruckDispatcher extends Component {

    constructor(props) {
      super(props);


      routesData.routesList.map((route) => {
        route.pathColor = this.getRandomColor();
        return null;
      })

      toastr.options.closeDuration = 200;

      this.state = {
        truckList: trucksData.truksList,
        routesList: routesData.routesList,
        selectedTruck: -1,
        showChatPanel: false,
        showDriverPanel: false
      }
    }

    getRandomColor = () => {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    onTruckSelect = (e) => {

      this.setState({
        selectedTruck: e.target.value,
      });

      if (e.target.value >= 0 ) {
          toastr.info('You have selected a new Truck');
      } else {
          toastr.warning('No truck selected...');
      }

    }

    onRouteSelect = (_id) => {

      let _rtl = this.state.routesList;

      _rtl.filter((route) => {
        return route._id === _id;
      }).map((route) => {
          //console.log(route);
          if (!route.selected) {
            toastr.success('You added a new route!');
          } else {
            toastr.error('You removed a route!');
          }

          route.selected = !route.selected;
          return null;
      });

      this.setState({
        routesList: _rtl
      });

    }

    getRouteList = () => {
      if (this.state.selectedTruck >= 0) {
        return routesData.routesList.filter((route) => {
          return route.truck === trucksData.truksList[this.state.selectedTruck]._id;
        })
      } else {
        return [];
      }
    }

    getSelectedRouteList = () => {
      if (this.state.selectedTruck >= 0) {
        return routesData.routesList.filter((route) => {
          return ((route.truck === trucksData.truksList[this.state.selectedTruck]._id) && (route.selected));
        })
      } else {
        return [];
      }
    }

    onChangeView = (e) => {
      this.props.history.push('/'+e);
    }

    openChatPanel = () => {
      this.setState({
        showChatPanel: true
      })
    }

    closeChatPanel = () => {
      this.setState({
        showChatPanel: false
      })
    }

    openDriverPanel = () => {
      this.setState({
        showDriverPanel: true
      })
    }

    closeDriverPanel = () => {
      this.setState({
        showDriverPanel: false
      })
    }

    render() {
        return(
            <div>
            <HeaderBar onChangeView={this.onChangeView} actualPosition={"Carrier View"}></HeaderBar>
            <Row className="gray-bg">
                <Col xs={4} sm={4} md={4} lg={4} >
                <span className="top-spacer"></span>
                    <CollapsablePanel title="Truck Selection">
                      <TruckSelectionPanel truckList={this.state.truckList} selectedTruck={this.state.selectedTruck} onTruckSelect={this.onTruckSelect} onOpenChatPanel={this.openChatPanel} onOpenDriverPanel={this.openDriverPanel}></TruckSelectionPanel>
                    </CollapsablePanel>

                    <CollapsablePanel title="Routes Available">
                      <RouteListPanel routesList={this.getRouteList()}  onRouteSelect={this.onRouteSelect}></RouteListPanel>
                    </CollapsablePanel>

                </Col>
                <Col xs={8} sm={8} md={8} lg={8} >
                    <span className="top-spacer"></span>
                    <CollapsablePanel title="Map">
                        <MapPanel routesList={this.getRouteList()}  onRouteSelect={this.onRouteSelect} selectedTruck={this.state.truckList[this.state.selectedTruck]}></MapPanel>
                    </CollapsablePanel>

                    <CollapsablePanel title="Summary and Chart">
                        {/*<SummaryPanel routesList={this.getRouteList()}></SummaryPanel>
                        <hr />*/}
                        <ChartPanel routesList={this.getRouteList()}></ChartPanel>
                    </CollapsablePanel>

                    <MessagePanelSmall></MessagePanelSmall>
                </Col>
            </Row>

            <ModalChatPanel showPanel={this.state.showChatPanel} onClose={this.closeChatPanel}></ModalChatPanel>

            <ModalDriverPanel showPanel={this.state.showDriverPanel} onClose={this.closeDriverPanel} data={this.state.truckList[this.state.selectedTruck]}></ModalDriverPanel>

            </div>
            );
    }
}
;



// WEBPACK FOOTER //
// ./src/pages/TruckDispatcher.js